/**
 * Checks if a user has a particular role.
 * @example
 * // returns true //if user.permissions includes "admin"
 * this.hasRole("admin");
 * @param {string || Array} permission - A string or an array of strings denoting the permission to be checked; consistent with options available in the user schema.
 * @param {Object} [user] - The user for whom the role availabilty is to be checked. Defaults to `this`
 **/
export function hasRole(permission, user = this) {
  try {
    if (user.permissions)
      return (
        user.permissions.includes("admin") ||
        user.permissions.some((role) => permission.includes(role))
      );
    // for backward compatibility
    return (
      user.admin || (permission === "ambassador" && user.ambassador) || false
    );
  } catch (err) {
    console.log("Error: ", err);

    return false;
  }
}

export function getLeadRole(user = this) {
  try {
    let leadRole = "user",
      permissions = user.permissions || [];
    if (permissions.length) {
      if (permissions.includes("coach")) leadRole = "coach";
      if (permissions.includes("coachCanSubmit")) leadRole = "coachCanSubmit";
      if (permissions.includes("admin")) leadRole = "admin";
    } else {
      //backward compatibility
      if (user.ambassador) leadRole = "ambassador";
      if (user.admin) leadRole = "admin";
    }
    return leadRole;
  } catch (err) {
    console.log("Error", err.message);
    return "user";
  }
}

export function hasRoleMiddleware(ctx, next) {
  // do stuff
  return next();
}
